import { PurchaseEntryResponseData } from "@lib/titan2-slingo/dist/api/data/PurchaseEntryResponseData";
import { SlingoConstants } from "@lib/titan2-slingo/dist/api/model/enum/SlingoConstants";
import { ExtendedGameProgressData } from "../../data/ExtendedGameProgressData";
/**
 * ExtendedPurchaseEntryResponseData.ts
 */
export class ExtendedPurchaseEntryResponseData extends PurchaseEntryResponseData {
    solidifyProgress() {
        let progressData = this.data.getDataObject(SlingoConstants.PROPERTY_GAME_PROGRESS);
        if (this.dataExists(progressData)) {
            this.progress = new ExtendedGameProgressData(progressData);
        }
    }
}
//# sourceMappingURL=ExtendedPurchaseEntryResponseData.js.map